import SchoolIcon from '@mui/icons-material/School';
import MemoryIcon from '@mui/icons-material/Memory';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import HealthAndSafety from '@mui/icons-material/HealthAndSafety';
import BuildIcon from '@mui/icons-material/Build';
import BrushIcon from '@mui/icons-material/Brush';
import PublicIcon from '@mui/icons-material/Public';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';


const categoryToIconMap = {
    education: SchoolIcon,
    technology: MemoryIcon,
    sport: SportsTennisIcon,
    food: LocalDiningIcon,
    health: HealthAndSafety,
    construction: BuildIcon,
    art: BrushIcon,
    politics: PublicIcon,
    // ... add other category-icon mappings as needed
};

export function getCategoryIcon(category) {
    const IconComponent = categoryToIconMap[category];
    return IconComponent ? <IconComponent /> : null;
}

export function formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
